export type ContractInterface = {
  Contract: ContractInfo;
  openAddZoneDialog: boolean;
};

export interface ContractZone {
  zone_id?: number;
  zone_name: string;
  report_zone_name?: string;
  contact_person?: string;
  tel?: string;
  email?: string;
  contract_report_sequence?: number;
  bin_count?: number;
  contract_id?: number;
}

export interface ContractImageType {
  cleaning_image_type_id?: number;
  image_type_name: string;
  image_type_name_en: string;
  report_column_name: string;
  is_active: number;
}

export interface ContractInfo {
  contract: string;
  is_active: string;
  need_inspect?: string;
  contract_id?:string
  image_type_id?:string
  report_title?:string
  zoneList?: ContractZone[]
  imageTypeList?: ContractImageType[]
}

export const initContractState: ContractInterface = {
  openAddZoneDialog: false,
  Contract: {
    contract: "",
    is_active: "1",
    need_inspect: "1",
    contract_id:"",
    image_type_id:"",
    report_title:"",
    zoneList: [],
    imageTypeList: [],
  },
};
